module.exports = __webpack_public_path__ + "static/media/sangria.423ff7dc.jpg";